import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { Proposal } from "../models"
import { ProposalEmailPayload } from "./types"

export class Service {
    static async get(hash: string): Promise<Proposal> {
        return AppContext.getApiClient().get(`/proposals/${hash}`)
    }

    static async sendByEmail(hash: string, payload: ProposalEmailPayload): Promise<Proposal> {
        return AppContext.getApiClient().post(`/proposals/${hash}/send-by-email`, payload)
    }
}


// WEBPACK FOOTER //
// ./src/state/proposal/services/service.ts